export default __webpack_public_path__ + "static/media/fb.764fb9cd.png";